module.exports = __webpack_public_path__ + "img/MUSIC.70fe27bf.svg";